(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kittybricks-newsletter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kb-newsletter')) {
    customElements.define('kb-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const input = this.querySelector('input[type="email"]');
        const status = this.querySelector('[role="status"]');
        if (!input || !status) return;
        input.addEventListener('invalid', (event) => {
          event.preventDefault();
          input.setAttribute('aria-invalid', 'true');
          status.className = 'kb-newsletter__status kb-newsletter__status--error';
          status.querySelector('.kb-newsletter__icon').textContent = '!';
          status.querySelector('[data-newsletter-message]').textContent = 'Enter a valid email address.';
          status.hidden = false;
          input.focus();
        });
        input.addEventListener('input', () => {
          input.removeAttribute('aria-invalid');
          status.hidden = true;
        });
        // Leave submission, validation and hCaptcha to Shopify's native customer form.
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
